module.exports = __webpack_public_path__ + "img/icon-confirm-delete.6ec4995a.svg";